import { useState } from "react";
import styled from "styled-components";

import NavItem from "./NavItem";
import FnrShineButton from "./FnrShineButton";
import {
  SectionTabBar,
  SectionTabButton,
  SectionTabBarWrapper,
} from "./SectionTabBar";

export default function Database() {
  const [selectedItem, setSelectedItem] = useState(false);
  return (
    <Wrapper>
      <SectionTabBarWrapper style={{ marginLeft: 32, marginRight: 32 }}>
        <SectionTabBar buttonsPerRow={2}>
          <SectionTabButton
            icon="fa-duotone fa-solid fa-database fa-swap-opacity"
            title="Database"
            itemKey="famreg"
            setSelectedItem={setSelectedItem}
            selectedItem={selectedItem}
          />
          <SectionTabButton
            icon="fa-duotone fa-solid fa-diagram-project"
            title="Parish Insights"
            itemKey="famreg"
            setSelectedItem={setSelectedItem}
            selectedItem={selectedItem}
          />
          <SectionTabButton
            icon="fa-duotone fa-solid fa-chart-diagram"
            title="Subnetworks"
            itemKey="famreg"
            setSelectedItem={setSelectedItem}
            selectedItem={selectedItem}
          />
          <SectionTabButton
            icon="fa-duotone fa-solid fa-address-book fa-swap-opacity"
            title="Family Registration"
            itemKey="famreg"
            setSelectedItem={setSelectedItem}
            selectedItem={selectedItem}
          />
        </SectionTabBar>
      </SectionTabBarWrapper>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding-bottom: 12px;
  position: relative;
`;
